import request from '@utils/request';
// import urlHost from '@common/urlHost';

// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=1a74c05c-9809-45b2-931c-a50c9040154f
// 发送短信验证码
export async function loginCodeSend(params) {
  const res = await request.post(`/api/official/user/code/send`, params);
  return res;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=7510d5b2-1b5d-47ec-b121-11e25ac682f6
// 点击按钮登录
export async function userLogin(params) {
  const res = await request.post(`/api/official/user/code/login`, params);
  return res;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=861945f5-a821-4465-9e60-db4ccdccdffc
// 判断手机号是否有对应简历
export async function resumeSuspected(params) {
  const res = await request.post(`/api/official/user/suspected/query`, params);
  return res;
}

interface IGetLoginStatus {
  // userId: number; // 用户ID
  // tenantId: string; // 租户
  avatarUrl: string; // 头像
  nickName: string; // 微信别名
  countryCode: string; // 国家码
  // areaName: string; // 地区名
  phone: string; // 电话
  // memo: string; //
  // staffMisId: string; // 如果绑定员工，员工的MIS号
  // staffTenantId: string; // 如果绑定员工，员工的租户Id （有可能其它租户的员工来看当前租户的职位信息）
  login: boolean; // 是否登录
  accountId: string;
  bindWechat: boolean; // 是否绑定微信号
  clientIp: string; // 客户端ip
}

// 获取登录状态
export async function getLoginStatus(): Promise<IGetLoginStatus> {
  const res: IGetLoginStatus = await request.post(`/api/official/user/current/get`, {});
  return res;
}

// 接口文档 http://papi.sankuai.com/index/#/papi/project/195fa07e-3250-496a-904f-d392c5d0ec81?apiId=06370fbb-54dd-4fdf-bb83-e70588460179
// 登出
export async function logout() {
  const res = await request.post('/api/official/user/logout', {});
  return res;
}
